import { Box, Typography } from '@mui/material';
import { useChildTokens } from './useChildTokens';
import { formatTime, remainingFraction, TimerViewProps, TIMER_SURFACE } from './timerView';

/**
 * Stående stapel — samma avläsning som den liggande, men tiden sjunker nedåt.
 *
 * Riktningen är hela poängen med att ha båda: en sjunkande pelare liknar en
 * timglas-/vätskenivå och läses av vissa lättare än en stapel som krymper i sidled.
 * Den fyllda delen ÄR tiden som är kvar. Ren renderare: tiden kommer som prop,
 * ingen egen setInterval (se timerView.ts).
 */
const BAR_WIDTH = 56;

const TimerBarVertical = ({
  time,
  totalSeconds,
  label,
  color,
  onToggle,
  showDigits = true,
}: TimerViewProps) => {
  const tokens = useChildTokens();
  const remainingPercent = remainingFraction(time, totalSeconds) * 100;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2.5 }}>
      <Box
        component="button"
        type="button"
        data-testid="timer-bar-vertical"
        onClick={onToggle}
        aria-label={label}
        sx={{
          height: TIMER_SURFACE,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          border: 'none',
          background: 'none',
          fontFamily: 'inherit',
          cursor: onToggle ? 'pointer' : 'default',
        }}
      >
        <Box
          sx={{
            width: BAR_WIDTH,
            height: '100%',
            borderRadius: '20px',
            bgcolor: tokens.border,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        >
          <Box
            data-testid="timer-bar-vertical-fill"
            sx={{
              width: '100%',
              height: `${remainingPercent}%`,
              borderRadius: '20px',
              bgcolor: color,
              transition: 'height 1s linear',
              '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {showDigits && (
            <Typography sx={{ fontSize: '2rem', fontWeight: 900, color: tokens.text }}>
              {formatTime(time)}
            </Typography>
          )}
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: tokens.textSoft }}>
            {label}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TimerBarVertical;
